import {pxmModbusConstants} from "../constants/pxm-modbus.constants";

const initialState = {
    pxmModbusScenes: null,
    pxmModbusCurrentScene: null
}

export function pxmModbusReducer(state = initialState, action) {
    switch (action.type) {
        case pxmModbusConstants.PXM_MODBUS_LIST_REQUEST:
        case pxmModbusConstants.PXM_MODBUS_LIST_FAILURE:
            return {
                ...state,
                pxmModbusScenes: null
            }
        case pxmModbusConstants.PXM_MODBUS_LIST_SUCCESS:
            return {
                ...state,
                pxmModbusScenes: action.scenesModel
            }
        case pxmModbusConstants.PXM_MODBUS_BY_ID_FAILURE:
        case pxmModbusConstants.PXM_MODBUS_BY_ID_REQUEST:
            return {
                ...state,
                pxmModbusCurrentScene: null
            }
        case pxmModbusConstants.PXM_MODBUS_BY_ID_SUCCESS:
            return {
                ...state,
                pxmModbusCurrentScene: action.sceneModel
            }
        default:
            return  state
    }
}
